import script from "./CloseCross.vue?vue&type=script&setup=true&lang=js"
export * from "./CloseCross.vue?vue&type=script&setup=true&lang=js"

import "./CloseCross.vue?vue&type=style&index=0&id=553d20a8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-553d20a8"]])

export default __exports__